import { EntraIdRoleRequestDto } from 'api/kmsapiclient'

import { EntraIdRolesList } from '../../components/entraIdRoles/types'
import {
  BaseActionType,
  DELETE_ENTRAID_ROLES_SUCCESS,
  GET_ENTRAID_ROLES_SUCCESS,
  UPSERT_ENTRAID_ROLES_SUCCESS,
} from '../../redux/actions/actionTypes'

import { EntraIdRolesState } from './initialState'

const initialStateEntraIdRoles: EntraIdRolesState = {
  entraIdRoles: [],
}

export const entraIdRolesReducer = (
  state = initialStateEntraIdRoles,
  action: BaseActionType,
): EntraIdRolesState => {
  switch (action.type) {
    case GET_ENTRAID_ROLES_SUCCESS: {
      const entraIdRoles = (action.payload as EntraIdRolesList).entraIdRoles
      return {
        entraIdRoles: entraIdRoles,
      }
    }
    case UPSERT_ENTRAID_ROLES_SUCCESS: {
      const combinedArray = [
        ...state.entraIdRoles.filter((entraIdRoles) => !!entraIdRoles.id),
        ...(action.payload as EntraIdRolesList).entraIdRoles,
      ]
      const map = new Map(
        combinedArray.map((entraIdRoles) => [entraIdRoles.id, entraIdRoles]),
      )
      return { entraIdRoles: Array.from(map.values()) }
    }
    case DELETE_ENTRAID_ROLES_SUCCESS: {
      const entraIdRoles = state.entraIdRoles.filter(
        (entraIdRoles: EntraIdRoleRequestDto) =>
          !(action.payload as EntraIdRolesList).entraIdRoles.some((deleted) =>
            deleted.id
              ? deleted.id === entraIdRoles.id
              : deleted.entraIdName === entraIdRoles.entraIdName,
          ),
      )

      return { entraIdRoles: entraIdRoles }
    }
    default:
      return state
  }
}
